const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* =================================================================
   UR MARK - AUTO-ADD FREE GIFT   (v7, 24 Sep 2026)

   Lives inside constants.js on purpose. Shopify changes this file's
   ?v= hash whenever it is edited, so browsers always pick up the
   latest version. A separate asset file did NOT reliably refresh.

   WHAT IT DOES
   Adds "Free Gift - Mini Pre-Inked Matte Stamp" once the cart has 2+
   eligible items, and removes it below 2.

   ELIGIBILITY
   Every product counts EXCEPT the gift itself, the bundle ids in
   blockingProductIds, anything carrying the 'bundle' tag, and the
   add-on ids in excludedProductIds (v6: ink refills, v7: ink pad).

   excludedProductIds vs blockingProductIds:
   - excluded = the item simply does not count toward the 2. The rest
     of the cart can still earn the gift. Use for add-ons (ink refills,
     ink pads).
   - blocking = the item switches the gift off for the WHOLE cart.
     Use for bundles only.

   Keep in step with snippets/cart-rewards.liquid, which draws the
   progress bar using the same rules.

   DISCOUNT SAFETY (the important part)
   Shopify applies only ONE automatic discount per order, and none of
   this store's codes combine with ours. If BUY2GET3 or any code wins,
   our gift is NOT discounted and the customer gets charged Rs.395.
   Three defences below:
     1. Refuse to add the gift while any other discount is on the cart.
     2. After adding, re-read the cart and rip the gift out if its
        line price is anything other than zero.
     3. On every cart change, re-check both of the above.

   To switch the whole thing off, delete from here to the end.
================================================================= */
(function () {
  'use strict';

  var CONFIG = {
    giftVariantId: 47579843428523,
    giftProductId: 8920264900779,
    threshold: 2,
    ourDiscountTitle: 'free gift on any 2 items',
    /* Bundles - gift is baked into the price, so never stack a gift on top. */
    blockingProductIds: [
      8943795208363, // Bundle of 3 Custom Acrylic Stamps
      8943910092971  // Complete Branding Kit
    ],
    /* Add-ons - never count toward the 2 items, but do not block the gift. */
    excludedProductIds: [
      9033215967403, // Permanent Stamp Ink Refill
      9033216032939, // Matte Stamp Ink Refill
      9033508126891  // Pigment Ink Pad (Little Birdie)
    ],
    giftNoteLabel: 'Design',
    giftNoteValue: 'Our team will contact you',
    debug: true
  };

  var R = window.routes || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URL_CART = R.cart_url ? R.cart_url + '.js' : ROOT + 'cart.js';
  var URL_ADD = R.cart_add_url ? R.cart_add_url + '.js' : ROOT + 'cart/add.js';
  var URL_CHANGE = R.cart_change_url ? R.cart_change_url + '.js' : ROOT + 'cart/change.js';

  var busy = false;
  var timer = null;
  var lastState = '';

  function log() {
    if (!CONFIG.debug) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift('[UrMark gift v7]');
    console.log.apply(console, a);
  }

  /* A cart line is a bundle if its id is blocked or it carries the tag. */
  function isBundleItem(item) {
    if (!item) return false;
    if (CONFIG.blockingProductIds.indexOf(item.product_id) !== -1) return true;
    if (Array.isArray(item.product_tags)) {
      for (var i = 0; i < item.product_tags.length; i++) {
        if (String(item.product_tags[i]).toLowerCase() === 'bundle') return true;
      }
    }
    return false;
  }

  /* Add-ons such as ink refills and ink pads never count toward the threshold. */
  function isExcludedItem(item) {
    if (!item) return false;
    return CONFIG.excludedProductIds.indexOf(item.product_id) !== -1;
  }

  function sectionsToRequest() {
    var ids = [];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (document.querySelector('cart-items')) {
      ids.push('main-cart-items');
      ids.push('main-cart-footer');
    }
    return ids;
  }

  function swap(html, selector) {
    if (!html) return;
    var incoming = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    var current = document.querySelector(selector);
    if (incoming && current) current.innerHTML = incoming.innerHTML;
  }

  function renderSections(sections) {
    if (!sections) return;
    swap(sections['cart-drawer'], '#CartDrawer');
    swap(sections['cart-icon-bubble'], '#cart-icon-bubble');
    swap(sections['main-cart-items'], '.js-contents');
    swap(sections['main-cart-footer'], '.js-contents');
    var d = document.querySelector('cart-drawer');
    if (d && sections['cart-drawer']) d.classList.remove('is-empty');
  }

  function getCart() {
    return fetch(URL_CART, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }

  function competingDiscounts(cart) {
    var found = [];
    function consider(t) {
      if (!t) return;
      if (String(t).toLowerCase() === CONFIG.ourDiscountTitle) return;
      if (found.indexOf(t) === -1) found.push(t);
    }
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (a && a.discount_application) consider(a.discount_application.title);
      });
      (it.discounts || []).forEach(function (d) { if (d) consider(d.title); });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a) consider(a.title);
    });
    (cart.discount_codes || []).forEach(function (d) {
      if (d && d.applicable !== false) consider(d.code);
    });
    return found;
  }

  /* Bundle exclusion: is a gift-blocking product sitting in the cart? */
  function blockingItems(cart) {
    var found = [];
    (cart.items || []).forEach(function (it) {
      if (isBundleItem(it)) {
        if (found.indexOf(it.product_id) === -1) found.push(it.product_id);
      }
    });
    return found;
  }

  function findGift(cart) {
    var g = null;
    (cart.items || []).forEach(function (i) {
      if (i.product_id === CONFIG.giftProductId) g = i;
    });
    return g;
  }

  function setGiftQty(key, qty) {
    log('set gift qty', qty);
    var body = { id: key, quantity: qty };
    var s = sectionsToRequest();
    if (s.length) body.sections = s.join(',');
    return fetch(URL_CHANGE, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function (d) { renderSections(d.sections); });
  }

  /* Defence 2: never leave a gift in the cart that is not free. */
  function ensureGiftIsFree() {
    return getCart().then(function (cart) {
      var g = findGift(cart);
      if (g && g.final_line_price > 0) {
        log('GIFT NOT FREE (' + g.final_line_price + ') - removing');
        lastState = '';
        return setGiftQty(g.key, 0);
      }
    });
  }

  function addGift() {
    log('adding gift');
    var props = {};
    props[CONFIG.giftNoteLabel] = CONFIG.giftNoteValue;
    var body = { items: [{ id: CONFIG.giftVariantId, quantity: 1, properties: props }] };
    var s = sectionsToRequest();
    if (s.length) body.sections = s.join(',');
    return fetch(URL_ADD, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function (d) { renderSections(d.sections); })
      .then(ensureGiftIsFree);
  }

  /* Everything counts except the gift itself, bundles and add-ons. */
  function inspect(cart) {
    var count = 0;
    (cart.items || []).forEach(function (it) {
      if (it.product_id === CONFIG.giftProductId) return;
      if (isBundleItem(it)) return;
      if (isExcludedItem(it)) return;
      count += it.quantity;
    });
    return { count: count, gift: findGift(cart) };
  }

  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true;

    return getCart().then(function (cart) {
      var s = inspect(cart);
      var competing = competingDiscounts(cart);
      var blocking = blockingItems(cart);
      var giftPrice = s.gift ? s.gift.final_line_price : -1;
      var sig = s.count + ':' + (s.gift ? s.gift.quantity : 0) + ':' + giftPrice +
                ':' + competing.join('|') + ':' + blocking.join('|');

      if (sig === lastState) { log('no change'); return; }
      lastState = sig;

      /* Defence 2 first - a charged gift is the worst outcome. */
      if (s.gift && giftPrice > 0) {
        log('GIFT NOT FREE (' + giftPrice + ') - removing');
        return setGiftQty(s.gift.key, 0);
      }

      /* Bundle exclusion - the bundle already includes its own stamps. */
      if (blocking.length) {
        log('bundle in cart:', blocking.join(', '), '- gift withheld');
        if (s.gift) return setGiftQty(s.gift.key, 0);
        return;
      }

      /* Defence 1 - another discount owns this cart. */
      if (competing.length) {
        log('other discount active:', competing.join(', '), '- gift withheld');
        if (s.gift) return setGiftQty(s.gift.key, 0);
        return;
      }

      var ok = s.count >= CONFIG.threshold;
      log('eligible:', s.count, '| qualifies:', ok, '| gift:', !!s.gift);

      if (ok && !s.gift) return addGift();
      if (ok && s.gift && s.gift.quantity > 1) return setGiftQty(s.gift.key, 1);
      if (!ok && s.gift) return setGiftQty(s.gift.key, 0);
    }).catch(function (e) {
      log('error:', e);
    }).then(function () {
      busy = false;
    });
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(reconcile, ms || 400);
  }

  var WATCH = /\/(cart\/(add|change|update|clear)|discount\/)/;

  if (window.fetch) {
    var _f = window.fetch;
    window.fetch = function () {
      var u = arguments[0];
      if (u && typeof u === 'object' && u.url) u = u.url;
      var hit = typeof u === 'string' && WATCH.test(u);
      return _f.apply(this, arguments).then(function (res) {
        if (hit && !busy) schedule();
        return res;
      });
    };
  }

  var _o = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    this._um = typeof u === 'string' && WATCH.test(u);
    return _o.apply(this, arguments);
  };
  var _s = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._um) this.addEventListener('load', function () { if (!busy) schedule(); });
    return _s.apply(this, arguments);
  };

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && WATCH.test(f.action)) schedule(1000);
  }, true);

  window.addEventListener('pageshow', function () { schedule(250); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(500); });
  } else {
    schedule(500);
  }

  log('ready - threshold', CONFIG.threshold);
})();
